<template>
    <div v-if="rollingStocks.length || service.supplierType === 'Free sale' || !service.stock">
        <div class="col-12 mt-5">
            <div>
                {{ service.service.title_NL }}<br />
                {{ serviceTypeName }} / {{ service.supplierType }}
            </div>
        </div>
        <template v-if="service.supplierType === 'Free sale' || !service.stock">
            <div v-if="item.statusCode === 'TODO'">
              <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">{{ $t('reservation.details.transport.notes') }}</small>
              </div>
              <div class="col-12 mt-2">
                <textarea class="form-control" rows="3" v-model="service.notes"></textarea>
              </div>
            </div>
            <div class="col-12">
                <reservation-details-free-sale-transport-time
                    v-if="times.length"
                    :key="timeCounter"
                    :times="times"
                    :departureDate="service.dateFrom"
                    :arrivalDate="service.dateUntil"
                    :originStation.sync="service.stationOrigin"
                    :destinationStation.sync="service.stationDestination"
                ></reservation-details-free-sale-transport-time>
            </div>
            <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">Bezetting</small>
                 <core-lever
                    class="ml-3 pt-1"
                    :label="$t('reservation.details.transport.show-data-to-customer')"
                    labelClass="ml-2"
                    :value="item.showData"
                    @input="(isChecked) => item.showData = isChecked"
                ></core-lever>
                <core-lever
                    class="ml-3 pt-1"
                    :label="$t('reservation.details.transport.show-prices-to-customer')"
                    labelClass="ml-2"
                    :value="item.showPrices"
                    @input="(isChecked) => item.showPrices = isChecked"
                ></core-lever>
            </div>
            <div class="col-12">
                <reservation-details-free-sale-service-type
                    :key="stockCounter"
                    :reservationId="reservationId"
                    :service="item.service"
                    :selectedTypes="item.reservationLines"
                    :outbound="service.outbound"
                    :departureDate="service.dateFrom"
                    :selectedClass="selectedClass"
                    :selectedRoomsAmount="selectedRoomsAmount"
                    :dataIsFilling="dataIsFilling"
                    :travelers="travelers"
                    @occupancyLoaded="setOccupancyLoaded"
                    @amountChanged="updateFreeSaleType"
                >
                </reservation-details-free-sale-service-type>
            </div>
            <div class="col-12 mt-2">
                <div class="d-flex row align-items-between">
                    <div class="col">
                        <span class="total-price-description">Subtotaal</span>
                    </div>
                    <div class="col-3 d-flex row align-items-center">
                        <core-money-input class="total-price-amount" :key="getSubTotal + ''" readonly :amount="getSubTotal"></core-money-input>
                    </div>
                </div>
            </div>
            <div v-if="((item.actionDate && item.actionDate !== 'NaN-NaN-NaN') || actionDateCalculated) && item.statusCode === 'TODO'" class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
              <small v-if="(item.actionDate && item.actionDate !== 'NaN-NaN-NaN')" class="green-text pl-2">Active action date: <strong>{{ formattedActionDate }}</strong> <button class="btn-custom-send white-text" @click="clearActionDate(item)">&#x2715;</button></small>
              <small v-if="(!item.actionDate || item.actionDate === 'NaN-NaN-NaN') && actionDateCalculated" class="red-text pl-2">Inactive action date: <strong>{{ actionDateCalculated }}</strong> <button class="btn-custom-send white-text" @click="activateActionDate(item)">&#10003;</button></small>
            </div>
            <div v-if="item.statusCode !== 'TODO'">
              <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">{{ $t('reservation.details.transport.notes') }}</small>
              </div>
              <div class="col-12 mt-2">
                <textarea class="form-control" rows="3" v-model="service.notes"></textarea>
              </div>
            </div>
            <div class="col-12 mt-2" v-if="item.statusCode === 'DONE'">
              {{ $t('reservation.booking-date') }}:<br/>
              <core-calendar
                :key="item.bookingDate"
                :date.sync="item.bookingDate"
              ></core-calendar>
            </div>
            <div v-if="item.statusCode === 'PENDING'">
              <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">{{ $t('reservation.booking-mail-sent-date') }}</small>
              </div>
              <div class="col-12 mt-2">
                <input class="form-control" type="text" readonly :value="item.bookingMailSentDate" />
              </div>
            </div>
            <div v-if="item.statusCode === 'DECLINED'">
              <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">{{ $t('reservation.booking-mail-declined-date') }}</small>
              </div>
              <div class="col-12 mt-2">
                <input class="form-control" type="text" readonly :value="item.bookingMailAnswerDate" />
              </div>
            </div>
            <div class="col-12 mt-2"><label><input type="checkbox" v-model="item.automaticallyBooked"> {{ $t('reservation.automatically-booked') }}</label></div>
            <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
              <small class="pl-2">{{ $t('reservation.details.accommodation.day-to-day-text') }}</small>
            </div>
            <div class="col-12 mt-2">
              <core-editor
                ref="newNoteEditor"
                class="col-sm-12 mb-2"
                v-model="item.dayToDayText"
              ></core-editor>
            </div>
            <reservation-details-media-box :reservationLineId="item.id" />
        </template>
        <template v-else>
            <div class="col-12 mt-3 pl-3" v-if="stockItems.length > 1">
                <div class="row">
                    <div class="col">
                        <core-basic-drop-down
                            :items="stockItems"
                            :selection.sync="selectedStock"
                            customLabel="Trein"
                            :simpleValue="false"
                        ></core-basic-drop-down>
                    </div>
                </div>
            </div>
            <div class="col-12 mt-2">
                <div class="pl-2 row d-flex align-items-center">
                    <div class="col-5">
                        <small
                            :class="{'font-weight-bold': isOutbound, 'font-italic': !isOutbound}"
                            class="p-0 ml-0"
                        >Heen</small>
                        <small
                            :class="{'font-weight-bold': !isOutbound, 'font-italic': isOutbound}"
                            class="p-0 ml-4"
                        >Terug</small>
                    </div>
                    <div class="col-7">
                        <core-lever
                            class="ml-3 pt-1 float-right"
                            label="Toon tijden aan klant"
                            labelClass="ml-2"
                        ></core-lever>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <reservation-details-transport-time
                    v-if="times.length"
                    :key="timeCounter"
                    :times="times"
                    :departureDate="service.dateFrom"
                    :arrivalDate="service.dateUntil"
                    :originStation.sync="service.stationOrigin"
                    :destinationStation.sync="service.stationDestination"
                ></reservation-details-transport-time>
            </div>
            <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">Transport</small>
                <core-lever
                    class="ml-3 pt-1"
                    label="Toon prijzen aan klant"
                    labelClass="ml-2"
                ></core-lever>
            </div>
            <div class="col-12" v-if="prices">
                <reservation-details-transport-type
                    :key="stockCounter"
                    :rollingStockId="getSelectedRollingStockId()"
                    :reservationLineId="getReservationLineId()"
                    :prices="getTransportTypePrices"
                    :selectedTypes="item.rollingStockCoupes"
                    @amountChanged="updateTravelersTransportType"
                >
                </reservation-details-transport-type>
            </div>
            <div class="col-12 mt-2">
                <div class="d-flex row align-items-between">
                    <div class="col">
                        <span class="total-price-description">Gemiddelde prijs per persoon (behalve prive accommodaties)</span>
                    </div>
                    <div class="col-3 d-flex row align-items-center">
                        <core-money-input class="total-price-amount" :key="getSubTotal + ''" readonly :amount="getSubTotal"></core-money-input>
                    </div>
                </div>
            </div>
            <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
                <small class="pl-2">Reizigers</small>
            </div>
            <div class="mt-1 col-12">
                <reservation-details-travelers
                    :key="travelersKey"
                    :rollingStockId="getSelectedRollingStockId()"
                    :reservationLineId="getReservationLineId()"
                    :serviceId="service.serviceId"
                    :travelers.sync="passengers"
                    :placements="placements"
                    @seatsChosen="seatsChosen"
                >
                </reservation-details-travelers>
            </div>
            <div class="mt-4 col-lg-12 d-flex align-items-center justify-content-between">
              <small class="pl-2">{{ $t('reservation.details.accommodation.day-to-day-text') }}</small>
            </div>
            <div class="col-12 mt-2">
              <core-editor
                ref="newNoteEditor"
                class="col-sm-12 mb-2"
                v-model="item.dayToDayText"
              ></core-editor>
            </div>
        </template>
    </div>
    <div v-else class="mt-5 ml-3 pt-2">
        <small class="ml-2 px-2 bg-danger text-white">Geen gegevens gevonden voor deze periode</small>
    </div>
</template>

<script>
import { rlProps } from '@/mixins/reservationLineProperties'
export default {
  mixins: [rlProps]
}
</script>

<style scoped>
  div >>> .btn {
    text-transform: capitalize;
    font-style: italic;
  }
  div >>> .btn:hover,
  div >>> .btn {
    text-decoration: none;
  }
  div >>> .btn.active {
    border: 0;
    font-weight: bold;
    font-family: "Open Sans Bold";
    font-style: normal;
    box-shadow: none !important;
  }
  div >>> .btn.btn-link {
    color: #767676 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reservation/details/Default.vue